import { Box } from '@mui/material'
import React from 'react'

interface CardData {
  id: number
  title: string
  content: string
   url?: string
}

interface Props {
  cards: CardData[]
}

export default function  KeyBenifit({ cards }: Props) {
  const [activeCard, setActiveCard] = React.useState(1)

  const handleCardClick = (cardId: number) => {
    setActiveCard(cardId)
  }

  return (
    <div className="flex flex-col items-center space-y-8 py-1 mx-auto px-4">
      <div className="flex flex-col items-stretch gap-4 w-full max-w-4xl">
        {cards.map((card) => {
          const isActive = activeCard === card.id
          return (
            <div
              key={card.id}
              className={`relative rounded-2xl cursor-pointer transition-all duration-500 ease-in-out ${
                isActive
                  ? 'bg-primary h-auto min-h-[200px] p-6'
                  : 'bg-primary text-white h-20'
              }`}
              onClick={() => handleCardClick(card.id)}
            >
              {/* Number */}
              <div className={`absolute ${isActive ? 'top-2 left-4' : 'top-6 left-4'} transform`}>
                <span className={`${isActive ? 'text-white' : 'text-white'} text-2xl font-semibold`}>
                  {String(card.id).padStart(2, '0')}
                </span>
              </div>

              {isActive ? (
                <Box className="flex flex-col md:flex-row gap-6 pt-6 text-white">
                  {/* Media */}
                  <div className="w-full md:w-64 h-48 bg-white rounded-xl overflow-hidden flex-shrink-0">
                    {card.url ? (
                      <img 
                        src={card.url} 
                        alt={card.title} 
                        className='w-full h-full object-cover'
                      />
                    ) : (
                      <img 
                        src="https://www.worldotutor.com/assets/images/logo.png" 
                        alt="worldotutor Logo" 
                        className='w-full h-full object-cover'
                      />
                    )}
                  </div>

                  {/* Content */}
                  <div className="flex-1 ">
                    {/* Title */}
                    <h3 className="text-xl md:text-2xl font-semibold mb-3">{card.title}</h3>
                    {/* Content */}
                    <p className="text-white/90 leading-relaxed text-sm md:text-base">
                      {card.content}
                    </p>
                  </div>
                </Box>
              ) : (
                <div className="h-full w-full flex items-center justify-between px-4 pl-16">
                  <span className="font-semibold text-lg">{card.title}</span>
                  <div className="w-8 h-8 rounded-full bg-white shadow flex items-center justify-center">
                    <span className="block w-0 h-0 border-l-[5px] border-l-gray-700 border-t-[3px] border-t-transparent border-b-[3px] border-b-transparent ml-0.5"></span>
                  </div>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}


